// Prolific completion-code wiring.
//
// Prolific (https://www.prolific.com) is the screened-participant research
// platform Yarit is using to recruit dementia caregivers for the Memory Lane
// study. When the participant finishes the study, they expect to receive a
// short completion code that they paste back into Prolific to mark the
// submission as complete (otherwise Prolific won't release their payment and
// the founder can't approve them).
//
// Prolific passes three query params on the study URL:
//   ?PROLIFIC_PID={{%PROLIFIC_PID%}}&STUDY_ID={{%STUDY_ID%}}&SESSION_ID={{%SESSION_ID%}}
// We capture all three; PROLIFIC_PID becomes the tester's iid so it shows up
// in admin/recent-logins, and STUDY_ID / SESSION_ID get stashed for later
// debugging if a tester says "Prolific didn't release my payment".

// Prolific completion code for the active study —
// "Memory Loss and Dementia Care Navigation" (updated 2026-02-28).
// Previously: "Memory Lane Care Tester" (cc=C1O8667A) — archived.
export const PROLIFIC_COMPLETION_CODE = "C1PAR2IC";
export const PROLIFIC_COMPLETION_URL = `https://app.prolific.com/submissions/complete?cc=${PROLIFIC_COMPLETION_CODE}`;

const SOURCE_KEY = "mlcn_source";
const STUDY_ID_KEY = "mlcn_prolific_study_id";
const SESSION_ID_KEY = "mlcn_prolific_session_id";

export function readProlificParams(search) {
    const params = new URLSearchParams(search || "");
    const pid = (params.get("PROLIFIC_PID") || params.get("prolific_pid") || "").trim();
    const studyId = (params.get("STUDY_ID") || params.get("study_id") || "").trim();
    const sessionId = (params.get("SESSION_ID") || params.get("session_id") || "").trim();
    return { pid, studyId, sessionId };
}

export function rememberProlificSource({ studyId, sessionId } = {}) {
    try {
        localStorage.setItem(SOURCE_KEY, "prolific");
        if (studyId) localStorage.setItem(STUDY_ID_KEY, studyId);
        if (sessionId) localStorage.setItem(SESSION_ID_KEY, sessionId);
    } catch (_e) { /* noop */ }
}

export function isProlificTester() {
    try {
        return localStorage.getItem(SOURCE_KEY) === "prolific";
    } catch (_e) {
        return false;
    }
}

export function getProlificContext() {
    try {
        return {
            studyId: localStorage.getItem(STUDY_ID_KEY) || "",
            sessionId: localStorage.getItem(SESSION_ID_KEY) || "",
        };
    } catch (_e) {
        return { studyId: "", sessionId: "" };
    }
}

export function clearProlificSource() {
    try {
        localStorage.removeItem(SOURCE_KEY);
        localStorage.removeItem(STUDY_ID_KEY);
        localStorage.removeItem(SESSION_ID_KEY);
    } catch (_e) { /* noop */ }
}
